import { Component } from '@angular/core';
import {RouterLink} from "@angular/router";
import {SubscribeComponent} from "../../common/subscribe/subscribe.component";

@Component({
  selector: 'app-team',
  standalone: true,
    imports: [
        RouterLink,
        SubscribeComponent
    ],
  templateUrl: './team.component.html',
  styleUrl: './team.component.scss'
})
export class TeamComponent {

}
